import TaskRow from './TaskRow'
import UserTime from '../../../user_time'
import {selectStatusByTask} from '../../../workflowStatus/selectors'
import {unsafe_selectWithState} from '../../../redux/utils'
import CommentsNumberContainer from '../../../taskManagement/components/CommentsNumberContainer'
import WorkflowStatusIcon from '../../../workflowStatus/WorkflowStatusIcon'
import ViewTTStore from '../ViewTTStore'
import TruncatedTextView from '../../../TruncatedTextView'

export default class ViewByCPTaskRow extends TaskRow {

    templateHtml() {
        return "<tr class='taskRow'>" +
               "  <td class='nameColumn'>" +
               "    <div class='subContainer'>" +
               "      <div class='iconNameContainer'>" +
               "        <div class='iconContainer'></div>" +
               "        <div class='name'><%-name%></div>" +
               "      </div>" +
               "      <div class='commentsNumberPlaceholder'></div>" +
               "    </div>" +
               "  </td>" +
               "  <td class='totalColumn'><div class='subContainer'><%-total%></div></td>" +
               "  <td class='detailsColumn'><div class='subContainer'></div></td>" +
               "</tr>"
    }

    templateModel() {
        const task = ViewTTStore.getTask(this.params.taskModel.taskId)
        return {
            name: task.name,
            total: UserTime.formatTimeWithDigitSeparator(this.params.taskModel.totalSpent)
        }
    }

    afterRender() {
        TaskRow.prototype.afterRender.call(this)
        const task = ViewTTStore.getTask(this.params.taskModel.taskId)
        new WorkflowStatusIcon(this.find(".iconContainer"), unsafe_selectWithState(state => selectStatusByTask(state, task))).init()

        this.commentsNumber = new CommentsNumberContainer().init(this.find('.commentsNumberPlaceholder'))
        this.commentsNumber.setState({commentsNumber: task.commentsNumber})

        new TruncatedTextView({text: task.description, lineCount: 5}).init(this.find('.detailsColumn > .subContainer'))
    }
}



// WEBPACK FOOTER //
// ./web/js/user/viewtt/detailsTable/ViewByCPTaskRow.js